"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenshotControls = void 0;
const UiElements_1 = require("../../ui/UiElements");
class ScreenshotControls {
    constructor(parentEl) {
        this.makeTransparentBackground = false;
        this.eventsHandler = {
            toggleTransparentOption: () => this.toggleTransparentOption()
        };
        if (!parentEl) {
            throw new Error("Parent element (screenshotControl) is undefined");
        }
        const title = this.createTitle();
        const element = this.createElement();
        parentEl.append(title.domEl, element.domEl);
    }
    dispose() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        (_b = (_a = this.screenshotButton) === null || _a === void 0 ? void 0 : _a.domEl) === null || _b === void 0 ? void 0 : _b.remove();
        (_d = (_c = this.screenshotedImage) === null || _c === void 0 ? void 0 : _c.domEl) === null || _d === void 0 ? void 0 : _d.removeAllListeners();
        (_f = (_e = this.screenshotedImage) === null || _e === void 0 ? void 0 : _e.domEl) === null || _f === void 0 ? void 0 : _f.remove();
        (_h = (_g = this.downloadButton) === null || _g === void 0 ? void 0 : _g.domEl) === null || _h === void 0 ? void 0 : _h.removeAllListeners();
        (_k = (_j = this.downloadButton) === null || _j === void 0 ? void 0 : _j.domEl) === null || _k === void 0 ? void 0 : _k.remove();
        (_m = (_l = this.uploadButton) === null || _l === void 0 ? void 0 : _l.domEl) === null || _m === void 0 ? void 0 : _m.removeAllListeners();
        (_p = (_o = this.uploadButton) === null || _o === void 0 ? void 0 : _o.domEl) === null || _p === void 0 ? void 0 : _p.remove();
    }
    toggleTransparentOption() {
        if (this.makeTransparentBackground) {
            this.makeTransparentBackground = false;
            return;
        }
        this.makeTransparentBackground = true;
    }
    createTitle() {
        return new UiElements_1.DivEl()
            .setClass('module-title')
            .setId('screenshotTitle')
            .addAttribute('data-i18n-key', 'SCREENSHOT');
    }
    createElement() {
        this.screenshotButton = new UiElements_1.ButtonEl()
            .setId('screenshotBtn')
            .addChild(new UiElements_1.SpanEl().addAttribute('data-i18n-key', 'TAKE_SCREENSHOT'));
        return new UiElements_1.DivEl()
            .setId('screenshotControls')
            .addChild(this.createScreenshotOptions())
            .addChild(this.screenshotButton)
            .addChild(this.createImageDiv());
    }
    createScreenshotOptions() {
        this.transparentBackgroundCheckbox = new UiElements_1.CustomCheckbox('TRANSPARENT_BACKGROUND', this.makeTransparentBackground);
        this.transparentBackgroundCheckbox.setEvent('click', this.eventsHandler.toggleTransparentOption);
        const container = new UiElements_1.DivEl().setId('screenshotOptions');
        container.domEl.appendChild(this.transparentBackgroundCheckbox.container);
        return container;
    }
    createImageDiv() {
        this.screenshotedImage = new UiElements_1.ImageEl('');
        this.uploadButton = new UiElements_1.ButtonEl()
            .setClass('right-bound')
            .addAttribute('data-i18n-attr', `data-title=SET_AS_THUMBNAIL`)
            .addChild(new UiElements_1.IconEl('thumbnail'));
        this.downloadButton = new UiElements_1.ButtonEl()
            .setClass('right-bound')
            .addAttribute('data-i18n-attr', `data-title=DOWNLOAD`)
            .addChild(new UiElements_1.IconEl('download'));
        this.screenshotedImage.setEvent('error', () => {
            var _a, _b, _c;
            (_a = this.screenshotedImage) === null || _a === void 0 ? void 0 : _a.setStyle({ display: 'none' });
            (_b = this.downloadButton) === null || _b === void 0 ? void 0 : _b.setStyle({ display: 'none' });
            (_c = this.uploadButton) === null || _c === void 0 ? void 0 : _c.setStyle({ display: 'none' });
        });
        this.screenshotedImage.setEvent('load', () => {
            var _a, _b, _c;
            (_a = this.screenshotedImage) === null || _a === void 0 ? void 0 : _a.setStyle({ display: 'block' });
            (_b = this.downloadButton) === null || _b === void 0 ? void 0 : _b.setStyle({ display: '' });
            (_c = this.uploadButton) === null || _c === void 0 ? void 0 : _c.setStyle({ display: '' });
        });
        const buttons = new UiElements_1.DivEl()
            .addChild(this.uploadButton)
            .addChild(this.downloadButton);
        return new UiElements_1.DivEl()
            .setId('screenshotImage')
            .addChild(new UiElements_1.DivEl().addChild(this.screenshotedImage))
            .addChild(buttons);
    }
}
exports.ScreenshotControls = ScreenshotControls;
